import { NormApi } from './norm'

export interface IBackgroundJob {
  id: string
  type: string
  created_at: string
  status: 'PENDING' | 'RUNNING' | 'COMPLETED' | 'FAILED'
  is_test_mode: boolean
  args: Record<string, any>
  result: Record<string, any>
}

export interface IGetListBackgroundJobPayload {
  app_id: string
  page: number
  page_size: number
}

export interface IAddBackgroundJobPayload {
  app_id: string
  type: 'export_tracking_log'
  is_test_mode?: boolean
}

export class BackgroundJobApi extends NormApi<IBackgroundJob> {
  list = async (payload: { app_id: string }) => {
    const response = await this.axios.get('/v1/background-job', {
      params: payload,
    })
    return this.responseHandler(response)
  }

  add = async (payload: IAddBackgroundJobPayload) => {
    const response = await this.axios.post('/v1/background-job', payload)
    return this.responseHandler(response)
  }
}

export default new BackgroundJobApi()
